export const resolveApiBaseUrl = (envApiUrl) => {
  if (envApiUrl === "") {
    return "";
  }
  return envApiUrl || "http://localhost:8080";
};

const PUBLIC_PROJECT_SLUGS = [
  "/conjunto-comercial-plinio-correa",
  "/galpao-industrial-sao-cristovao",
  "/condominio-vila-nova",
  "/infraestrutura-do-loteamento-jatoba",
];

export const isPublicAppRoute = (pathname = "") => {
  if (!pathname || pathname === "/") {
    return true;
  }

  if (pathname === "/login") {
    return true;
  }

  if (pathname.startsWith("/os/public")) {
    return true;
  }

  if (pathname.startsWith("/projetos/")) {
    return true;
  }

  return PUBLIC_PROJECT_SLUGS.includes(pathname);
};

export const shouldRedirectToLoginOn401 = ({
  status,
  requestUrl = "",
  pathname = "",
  retried = false,
}) => {
  const onPublicOsPage = pathname.startsWith("/os/public");

  return (
    status === 401 &&
    !retried &&
    !String(requestUrl).includes("/login") &&
    !String(requestUrl).includes("/public/") &&
    !onPublicOsPage &&
    pathname !== "/login" &&
    !isPublicAppRoute(pathname)
  );
};

export const shouldAttachBearerToken = (token) => Boolean(token);

export const shouldRemoveJsonContentType = (data) => data instanceof FormData;
